const AUTHENTICITY_TOKEN_ERROR_MESSAGE = 'Sorry, your request could not be processed as it contained an invalid security token. Please refresh and try again.'

type Functor<T, K> = (args?: K) => Promise<T>
export const XsrfResilient = <T, K >(asyncFunctor: Functor<T, K>) => async (args?: K) => {
  try {
    return await asyncFunctor(args)
  } catch (possibleXsrfResponse) {
    const error = String(possibleXsrfResponse?.response?.data?.error)
    if (error === AUTHENTICITY_TOKEN_ERROR_MESSAGE) {
      return await asyncFunctor(args)
    }
    throw possibleXsrfResponse
  }
}

export default XsrfResilient
